export const inputClass =
    "w-full p-2 text-base bg-[#333] text-white border border-[#555] rounded-md";